export default function InfoItem({ value, sub }) {
  return (
    <div className="py-2.5">
      <p className="text-blue-600 font-extrabold text-2xl leading-snug">{value}</p>
      {sub && <p className="text-gray-400 text-sm mt-0.5">{sub}</p>}
    </div>
  );
}